import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';

const LANDING_ROUTES: [permission: string, route: string][] = [
  ['calendar.index', 'calendar'],
  ['insights', 'insights'],
  ['calendar.reports', 'calendar.reports'],
  ['calendar.inbox', 'calendar.inbox'],
  ['inbox.team', 'calendar.inbox'],
  ['dashboard.index', 'dashboard'],
  ['action', 'action.index'],
  ['clients.index', 'clients'],
  ['client_statements.index', 'clients.statements'],
  ['upsells.index', 'upsells'],
  ['automate', 'automate'],
  ['direct', 'direct'],
  ['outbound.messages', 'outbound.messages'],
];

export default class IndexRoute extends ProtectedRoute {
  @service subscription!: Services['subscription'];
  @service newVersionNotifier!: Services['new-version-notifier'];
  @service featureFlags!: Services['feature-flags'];

  @service crisp!: Services['crisp'];

  @service userflow!: Services['userflow'];

  @service('repositories/account-configuration')
  accountConfigurationRepository!: Services['repositories/account-configuration'];

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    await this.redirectAfterLogin();
  }

  public async redirectAfterLogin(): Promise<void> {
    const route = this.#getRouteForAuthenticated();

    // does some stuff from the application afterModel hook, because we load some of the data here
    // but when user just logged in, application afterModel hook was executed, but user being not authenticated
    // so we need to do the rest of the authentication piece logic
    await Promise.all([
      this.session.fetchCurrentUser(),
      this.accountConfigurationRepository.findRecord('me'),
    ]);

    await this.featureFlags.initialize();

    // Re-run Crisp/Userflow setup: the application afterModel ran pre-login.
    this.crisp.configure();
    this.userflow.configure();

    this.subscription.checkPaused();
    this.newVersionNotifier.listenForNewRelease.perform();

    this.router.transitionTo(route);
  }

  #getRouteForAuthenticated(): string {
    const { currentUser } = this;

    const landing = LANDING_ROUTES.find(([permission]) =>
      currentUser.hasAccessTo(permission),
    );

    return landing?.[1] ?? 'no-access';
  }
}
